import React from 'react'
import styled from 'styled-components'
import useDataFetcher from '../../../knisot/hooks/useFetchData'
import { Workers } from '../../../../../../modules/API/Workers/workers'
import { IWorkerHistoryResponse } from '../../../../../../modules/API/Workers/models/workerHistory'
import { Loader } from '../../../../../../generic/ui/Loader'
import { Surface, ScrollArea } from '../../../../../../generic/ui/Surface'
import { buildWorkerHistoryRowView } from '../helpers/workerHistory'
import WorkerHistoryCard from './WorkerHistoryCard'

interface WorkerHistoryModalProps {
    orderId: number | string
    closeFunc?: () => void
}

const WorkerHistoryModal: React.FC<WorkerHistoryModalProps> = ({ orderId }) => {
    const { data, isLoading, error } = useDataFetcher<IWorkerHistoryResponse>(
        Workers.getWorkerHistoryByOrderID,
        orderId.toString()
    )

    // useDataFetcher starts with isLoading=false — the (!data && !error) leg
    // keeps the first frame on the loader instead of flashing the empty state.
    if (isLoading || (!data && !error)) {
        return (
            <CenterState>
                <Loader size={56} />
            </CenterState>
        )
    }

    if (error) {
        return <ErrorMessage>שגיאה בטעינת היסטוריית שיוך מלקטים</ErrorMessage>
    }

    const items = data?.items ?? []

    if (items.length === 0) {
        return <EmptyMessage>אין היסטוריית שיוך מלקטים להזמנה זו</EmptyMessage>
    }

    return (
        <ContentSurface>
            <ScrollArea>
                {items.map((item, index) => (
                    <WorkerHistoryCard
                        key={`${item.changed_at}-${index}`}
                        view={buildWorkerHistoryRowView(item)}
                        isLast={index === items.length - 1}
                    />
                ))}
            </ScrollArea>
        </ContentSurface>
    )
}

export default WorkerHistoryModal

const ContentSurface = styled(Surface)`
    max-height: min(60vh, 30rem);
`

const CenterState = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
`

const EmptyMessage = styled.div`
    padding: 2rem;
    text-align: center;
    color: ${({ theme }) => theme.colors.ink3};
    font-size: ${({ theme }) => theme.text.md};
    font-family: ${({ theme }) => theme.fonts.sans};
`

const ErrorMessage = styled(EmptyMessage)`
    color: ${({ theme }) => theme.colors.danger};
`
